import { render, staticRenderFns } from "./dabaoDetails.vue?vue&type=template&id=15f8350e&scoped=true&"
import script from "./dabaoDetails.vue?vue&type=script&lang=js&"
export * from "./dabaoDetails.vue?vue&type=script&lang=js&"
import style0 from "./dabaoDetails.vue?vue&type=style&index=0&id=15f8350e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8350e",
  null
  
)

export default component.exports